function optionalBoolean(value) {
  if (value === undefined || value === null || String(value).trim() === "") return null;
  const normalized = String(value).trim().toLowerCase();
  if (["true", "1", "yes", "on"].includes(normalized)) return true;
  if (["false", "0", "no", "off"].includes(normalized)) return false;
  return null;
}

const configuredSimulationControls = optionalBoolean(
  process.env.REACT_APP_GPS_SIMULATION_CONTROLS_ENABLED
);

export const GPS_SIMULATION_CONTROLS_ENABLED =
  configuredSimulationControls === null
    ? process.env.NODE_ENV !== "production"
    : configuredSimulationControls;

